import type { MembershipState } from './types';

export const MEMBERSHIP_TRIAL_SCOPE =
  'Free trial includes the pre-assessment, curriculum, and sessions 1–2.';

export const MEMBERSHIP_FULL_SCOPE =
  'Full membership unlocks all 12 sessions, growth reports, and the post-assessment from day one.';

/** Shown once above plan cards when trial vs paid start is offered. */
export const MEMBERSHIP_PURCHASE_CHOICE_EXPLAINER =
  `${MEMBERSHIP_TRIAL_SCOPE} Subscribe now unlocks all 12 sessions, growth reports, and the post-assessment from day one.`;

export function isMembershipTrialing(
  membership: MembershipState | null | undefined,
): boolean {
  return membership?.status === 'trialing';
}

/** First-time buyers may pick trial or paid start; not while already trialing or subscribed. */
export function canShowFreeTrialChoice(
  membership: MembershipState | null | undefined,
  trialLabel: string | null | undefined,
): boolean {
  if (!trialLabel) {
    return false;
  }
  const status = membership?.status ?? 'none';
  return status !== 'trialing' && status !== 'active';
}
